import { createAction } from '@reduxjs/toolkit'

export const confirm = createAction('confirmation/confirm')
export const takeOut = createAction('confirm/takeOut')